/// <amd-module name="VSS/Platform/UserClaims" />
import { IVssPageContext, IVssService, Services, VssService } from "./Context";
import { IVssContributionService } from "./Contribution";

export const enum UserClaims {
    /**
     * User is not authenticated.
     */
    Anonymous = "anonymous",

    /**
     * User carrying this claim is not a member of the current project but a member of the current account.
     */
    Public = "public",

    /**
     * User carrying this claim is a member of the current project.
     */
    Member = "member"
}

export interface IVssUserClaimsService extends IVssService {
    /**
     * Checks whether current user has the specified claim or not.
     *
     * @param {string} claim User claim to check.
     * @returns {boolean}
     */
    hasClaim: (claim: string) => boolean;
}

class VssUserClaimsService extends VssService implements IVssUserClaimsService {
    private claims: { [claim: string]: boolean };

    public hasClaim(claim: string): boolean {
        if (!this.claims) {
            // Get claims from the shared data
            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
            this.claims = contributionService.getData<{ [claim: string]: boolean }>("ms.vss-web.user-claims-data") || this.getDefaultClaims();
        }

        claim = (claim || "").toLowerCase();
        return this.claims[claim];
    }

    private getDefaultClaims(): { [claim: string]: boolean } {
        const defaultClaims: { [claim: string]: boolean } = {};
        defaultClaims[UserClaims.Member] = true;

        return defaultClaims;
    }
}

Services.add("IVssUserClaimsService", { serviceFactory: VssUserClaimsService });
/**
 * Checks whether current user has the specified claim or not.
 *
 * @param {string} claim User claim to check.
 * @param pageContext The active pageContext.
 * @returns {boolean}
 */
export function userHasClaim(pageContext: IVssPageContext, claim: string): boolean {
    const userClaimService = pageContext.getService<IVssUserClaimsService>("IVssUserClaimsService");
    return userClaimService.hasClaim(claim);
}
